var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 105,
    viewBox: "0 0 103 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.862 9.632a2 2 0 012.27-1.686l28.542 4.22c5.253.739 8.961 5.538 8.211 10.79L92.259 96.793c-.757 5.244-5.665 8.851-10.923 8.108a1.197 1.197 0 01-.102-.017l-38.116-7.422a2 2 0 01.764-3.927l38.062 7.412c3.101.413 5.923-1.724 6.356-4.725L98.925 22.39v-.002c.43-3.005-1.691-5.826-4.812-6.263l-.016-.002-28.55-4.221a2 2 0 01-1.685-2.271z",
    fill: "#363637"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.548 4.198h-.003L9.192 16.162c-3.122.824-4.786 3.796-3.992 6.53l20.382 69.89c.812 2.78 3.944 4.567 7.113 3.745h.003l45.355-11.965c3.117-.818 4.784-3.794 3.99-6.53L61.652 7.945c-.807-2.783-3.943-4.569-7.105-3.747zM65.494 6.83C64.034 1.796 58.621-.996 53.538.327l-.006.002-45.36 11.965c-5.111 1.35-8.286 6.442-6.813 11.514l20.383 69.895c1.468 5.024 6.872 7.817 11.962 6.495l.007-.002 45.357-11.965h.002c5.115-1.343 8.286-6.446 6.814-11.514l-.001-.003L65.495 6.832l-.001-.002z",
    fill: "#363637"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.419 38.24c-5.03-2.845-8.215-4.593-8.215-4.593s-1.841 3.137-4.689 8.16c-1.505 2.65-4.754 9.095-3.338 14.218a6.417 6.417 0 007.895 4.476 6.405 6.405 0 004.46-4.442v.002a.67.67 0 01.42-.377c.32-.088.67.056.715.344.27 1.908.488 6.735-3.177 9.399l12.07-3.337c-4.511-.404-6.803-4.658-7.549-6.434-.112-.269.117-.573.436-.661a.68.68 0 01.553.108L48 55.1a6.393 6.393 0 006.105 1.521 6.419 6.419 0 004.476-7.894c-1.416-5.124-7.514-8.985-10.163-10.488z",
    fill: "#363637"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.97 40.035l3.1 4.7 5.43-1.502-3.51 4.405 3.105 4.697-5.272-1.976-3.51 4.403.25-5.624-5.274-1.976 5.433-1.502.247-5.625z",
    fill: "#525252"
  })));
}
SvgNoDataCard.displayName = 'NoDataCard';
export default SvgNoDataCard;